module.exports = __webpack_public_path__ + "static/media/trash.83e87155.svg";